import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-EPM",
  "use": "dv-EPM-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-EPM\"><defs><style>#dv-EPM .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>资源 2</title><g id=\"dv-EPM_图层_2\" data-name=\"图层 2\"><g id=\"dv-EPM_图层_1-2\" data-name=\"图层 1\"><path id=\"dv-EPM_矩形_279\" data-name=\"矩形 279\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path d=\"M11.16 10.34h-.51v1.54h.54a1.1 1.1 0 0 0 .83-.25.71.71 0 0 0 .18-.56c0-.44-.2-.73-1.04-.73z\" /><path d=\"M20.21 2.5H3.79A1.29 1.29 0 0 0 2.5 3.79v16.42a1.29 1.29 0 0 0 1.29 1.29h16.42a1.29 1.29 0 0 0 1.29-1.29V3.79a1.29 1.29 0 0 0-1.29-1.29zm-11.3 12H5.85V9.53h3v.83h-2v1.12h1.68v.83H6.79v1.33h2.12zm2.35-1.79h-.61v1.79h-1V9.53h1.54c1.26 0 1.9.52 1.9 1.54s-.63 1.61-1.83 1.61zm6.89 1.79h-.89v-3.26l-.15.42L16.3 14h-.6l-.85-2.32-.16-.44a7.41 7.41 0 0 1 0 .78v2.44h-.87V9.53h1v.07l.96 2.4c.06.16.11.33.16.48a2.25 2.25 0 0 0 .08.24c0-.08.05-.16.07-.24s.1-.32.16-.47l.87-2.47h1z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-EPM.svg
// module id = IXNn
// module chunks = 6